import Vue from 'vue';
import store from './../../store';
import clientGroupTransformer from './../../transformers/clientGroup';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const clientGroups = clientGroupTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedClientGroups', { clientGroups, pagination });
  resolve(data);
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('client_groups', options))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/items.js